import React, { useState, useEffect } from "react";
import { Link } from "react-router";
import MenuItems from "./MenuItems";
import normalLogo from "@logos/RDEC-BLUE-NOBG.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";

const HeaderView = (props: {
  topbarEnable: boolean;
  parentMenu: any;
  headerNormalLogo: string;
}) => {
  const { topbarEnable, parentMenu, headerNormalLogo } = props;

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 flex w-full flex-col bg-white shadow-md">
      {/* Topbar Section */}
      {topbarEnable && (
        <div className="bg-gray-100 py-2">
          <div className="mx-auto flex items-center justify-between">
            <div className="ml-5 flex items-center space-x-6 px-4">
              <a
                href="mailto:contato@rdec.com.br"
                className="flex items-center gap-2 text-sm text-gray-600"
              >
                <p className={`hidden md:block`}>Solicitar contato:</p>
                <FontAwesomeIcon icon={faEnvelope} />
                contato@rdec.com.br
              </a>
            </div>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-500 hover:text-blue-500">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="#" className="text-gray-500 hover:text-blue-500">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="text-gray-500 hover:text-blue-500">
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
      )}

      {/* Main Header */}
      <div className={`bg-white`}>
        <hr className={`h-4 w-full bg-primary-700`} />
        <div className="mx-6 flex items-center justify-between px-4">
          <Link to="/" className="mr-5 flex items-center p-4">
            <img
              src={headerNormalLogo || normalLogo}
              alt="Restart Design & Consulting Logo"
              className="w-44"
            />
          </Link>
          <button
            className="text-gray-600 lg:hidden"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span className="sr-only">Toggle Menu</span>
            <svg
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          </button>
          <nav className={`hidden w-full space-x-4 lg:flex`}>
            <MenuItems parentMenu={parentMenu} />
          </nav>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="bg-white shadow-md lg:hidden">
          <nav className="p-4">
            <MenuItems parentMenu={parentMenu} />
          </nav>
        </div>
      )}
    </header>
  );
};

export default HeaderView;
